import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import TabsSection from "../../Components/Tabs/TabsSection";
import SideBar from "../SideBar/SideBar";
import { ManageTemplate } from "./ManageTemplate";
import { BulkNotify } from "./BulkNotify";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";

export const Communication = () => {
  const [currentTab, setcurrentTab] = useState("");
  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "manage-templates") {
      setcurrentTab("manage-templates");
    }
    if (endPath[4] === "bulk-notify") {
      setcurrentTab("bulk-notify");
    }
  }, [path]);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Communications</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />

            {/* start */}
            {currentTab == "manage-templates" && <ManageTemplate />}

            {currentTab == "bulk-notify" && <BulkNotify />}

            {/* end */}
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};
